import { render } from "./ImageExpandable.vue?vue&type=template&id=2098fd4c&scoped=true"
import script from "./ImageExpandable.vue?vue&type=script&lang=js"
export * from "./ImageExpandable.vue?vue&type=script&lang=js"

import "./ImageExpandable.vue?vue&type=style&index=0&id=2098fd4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2098fd4c"]])

export default __exports__